import { SingleOutsource } from './SingleOutsource';

import { useLocalPendingEntries } from 'providers/PendingActions';

import { OutsourceData } from './types';

export type OutsourceDataComposed = OutsourceData & { serviceName: string };

export function OutsourceAuthorization(): JSX.Element {
  const outsources = useLocalPendingEntries('OUTSOURCE_AUTHORIZATION');

  return (
    <>
      {outsources.map((outsource) => (
        <SingleOutsource
          key={`outsource-${outsource.projectId}-${outsource.id}`}
          outsource={outsource}
        />
      ))}
    </>
  );
}
